/**
 * Created by mark on 6/10/2019.
 */
import Service from "../../../Services/index";

const BagType = {
    namespaced: true,
    state: {
        bagTypeList:[],
        dataPaginate:{
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        },
        form:{
            id : "",
            name : ""
        },
        search:{
            name: ""
        }
    },
    mutations: {
        GET_BAG_TYPE_LIST: (state, res) => {
            state.bagTypeList = res.data
            state.dataPaginate = {
                current_page :res.current_page,
                from : res.from,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            }
        },
        GET_BAG_TTYPE_BY_ID:(state,res)=>{
            state.form = res;
        },
        CLEAR_DATA:(state)=>{
            state.form = {
                id : "",
                name : ""
            }
        },
        CLEAR_SEARCH:(state)=>{
            state.search = {
                name : ""
            }
        },
    },
    actions: {
        setBagType({ commit },page=1) {
            return Service.BagType.getBagType(page).then(response => {
                commit("GET_BAG_TYPE_LIST", response);
            });
        },
        showBagType({ commit },id) {
            return Service.BagType.showBagType(id).then(response => {
                commit("GET_BAG_TTYPE_BY_ID", response);
            });
        },
        saveBagType({ state, commit },id) {
            let data = {
                name : state.form.name
            };
            if(!id){ //create
                return Service.BagType.createBagType(data);
            }
            else { //update
                return Service.BagType.updateBagType(id,data);
            }
        },
        deleteBagType({ commit },id) {
            return Service.BagType.deleteBagType(id);
        },
        clearData({commit}){
            commit("CLEAR_DATA");
        },
        search({commit},data){
            return Service.BagType.searchBagType(data).then(res=>{
                commit("GET_BAG_TYPE_LIST",res)
            })
        },
        clearSearch({commit}){
            commit("CLEAR_SEARCH");
        },
    }
};
export default BagType;
